import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  stopIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.redMuted,
    borderRadius: theme.borderRadius.std,
  },
  roundShape: {
    width: theme.marginBase * 2.5,
    height: theme.marginBase * 2.5,
    borderRadius: '50%',
  },
  roundedSquareShape: {
    width: theme.marginBase * 3,
    height: theme.marginBase * 3,
  },
  stopIcon: {
    color: theme.colors.red,
  },
}));

interface Props {
  isRound?: boolean;
  isRoundedSquare?: boolean;
}

export const StopIconWithBg = ({ isRound, isRoundedSquare }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div
      className={classnames(classes.stopIconContainer, {
        [classes.roundShape]: !!isRound,
        [classes.roundedSquareShape]: !!isRoundedSquare,
      })}
    >
      <i className={classnames('ri-spam-3-fill', classes.stopIcon)} />
    </div>
  );
};
